var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', [!_vm.editableRows.length ? _c('Placeholder', {
    attrs: {
      "icon": "warehouse",
      "title": _vm.$translate('emptyTitle'),
      "description": _vm.$translate('emptyHelp'),
      "min-height": 0,
      "actions": [{
        action: 'add',
        text: _vm.$translate('add'),
        main: true,
        disabled: _vm.disabled
      }]
    },
    on: {
      "add": _vm.add
    }
  }) : [_c('p', {
    staticClass: "text-caption text--secondary"
  }, [_vm._v(_vm._s(_vm.$translate('help')))]), _vm._l(_vm.editableRows, function (_ref) {
    var location = _ref.location,
      index = _ref.index;
    return _c('div', {
      key: location.id || "new-".concat(index),
      staticClass: "d-flex align-start mb-3"
    }, [_c('v-text-field', {
      ref: 'location-' + index,
      refInFor: true,
      attrs: {
        "value": location.name,
        "label": _vm.$translate('name'),
        "outlined": "",
        "dense": "",
        "hide-details": "auto",
        "maxlength": "128",
        "disabled": _vm.disabled || location.archived
      },
      on: {
        "input": function input($event) {
          return _vm.change(index, {
            name: $event
          });
        }
      }
    }), _c('v-btn', {
      staticClass: "ml-2 align-self-end flex-shrink-0",
      attrs: {
        "icon": "",
        "width": "40",
        "height": "40",
        "disabled": _vm.disabled,
        "aria-label": _vm.$translate(location.archived ? 'restore' : 'remove')
      },
      on: {
        "click": function click($event) {
          return _vm.remove(index);
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(location.archived ? 'mdi-restore' : 'mdi-delete-outline'))])], 1)], 1);
  }), _c('v-btn', {
    attrs: {
      "outlined": "",
      "small": "",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.add
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(_vm._s(_vm.$translate('add')))], 1)], _vm.errors ? _c('div', {
    staticClass: "error--text text-caption mt-2",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.errorText))]) : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }